






import Vue from "vue";
import coreApiClient from "@/services/apis/coreApiClient";
import userManager from "@/services/userManager";
import appService from "@/services/appService";
import configProvider from "@common/services/configProvider";

export default Vue.extend({
  data() {
    const isFleetEnabled = !!configProvider.get("fleet")?.enabled;
    return {
      tableOptions: {
        attrs: {
          "item-key": "_id",
          "sort-by": "name",
          "sort-desc": false,
        },
        content: {
          name: "Organizations",
          urlEnabled: true,
          search: {
            ext: {
              hidden: true,
            },
          },
          filters: {
            filters: {
              name: {
                attrs: {
                  label: "Organization",
                },
                rules: {
                  match: {},
                },
              },
              subdomain: {
                attrs: {
                  label: "Subdomain",
                },
                rules: {
                  match: {},
                },
              },
              email: {
                attrs: {
                  label: "Business Email",
                },
                rules: {
                  match: {},
                },
              },
              cpoGroupId: {
                type: "XAutocomplete",
                attrs: {
                  label: "Partner",
                  "item-value": "_id",
                  "item-text": "name",
                  clearable: true,
                  xOptions: {
                    content: {
                      async itemsSuggestor(search, value, limit) {
                        const { items } = await coreApiClient.call("cpoGroups", "findAll", {
                          payload: JSON.stringify({
                            limit,
                            search,
                            orderBy: "name",
                            orderType: "asc",
                            filters: [
                              {
                                key: "_id",
                                operator: "equal_to",
                                value,
                              },
                            ],
                          }),
                        });
                        return items;
                      },
                    },
                  },
                },
                rules: {
                  equal_to: {},
                },
              },
            },
          },
          displayFields: {
            name: {
              text: "Organization",
              sortable: true,
            },
            subdomain: {
              text: "Subdomain",
              sortable: true,
            },
            email: {
              text: "Business Email",
              sortable: true,
            },
            electricityTariff: {
              text: "Electricity Tariff",
              sortable: true,
              options: {
                subProp: "setting.chargingSessionPointPerKwh",
                transform: (value: number, row: any) => {
                  const tariff = value != null ? value.toFixed(2) : "0.00";
                  const currency = row?.setting?.exchangeRatioFromCurrency?.toUpperCase() || "VND";
                  return `${tariff} ${currency}`;
                },
              },
            },
            ratio: {
              text: "Ratio",
              sortable: true,
              options: {
                transform: (value: number) => {
                  return value != null ? value.toFixed(2) : "1.00";
                },
              },
            },
            cpoGroup: {
              text: "Partner",
              sortable: true,
              options: {
                subProp: "cpoGroup.name",
                transform: (value) => {
                  return value || "";
                },
              },
            },
            isPostpaid: {
                text: "Payment methods",
                options: {
                  boolean: true,
                  label: (value: boolean) => {
                      return value ? "Postpaid" : "Prepaid";
                  },
                  attrs(value) {
                      return {
                          color: value ? "red" : "green",
                      };
                  },
              },
            },
            crossPayment: {
              text: "Cross Payment",
              options: {
                boolean: true,
                label: (value: boolean) => {
                    return value ? "Yes" : "No";
                },
                attrs(value) {
                    return {
                        color: value ? "green" : "red",
                    };
                },
              }
            },
            isCrossCharging: {
              text: "Cross Charging",
              options: {
                boolean: true,
                subProp: "setting.isCrossCharging",
                label: (value: boolean) => {
                    return value ? "Yes" : "No";
                },
                attrs(value) {
                    return {
                        color: value ? "green" : "red",
                    };
                },
              }
            },
            isInvoiceEnabled: {
              text: "Enable Invoice",
              options: {
                boolean: true,
                subProp: "setting.isInvoiceEnabled",
                label: (value: boolean) => {
                    return value ? "Yes" : "No";
                },
                attrs(value) {
                    return {
                        color: value ? "green" : "red",
                    };
                },
              }
            },
            disabled: {
              text: "Status",
              options: {
                boolean: true,
                label: (value: boolean) => {
                  return value ? "Disabled" : "Active";
                },
                attrs(value) {
                  return {
                    color: value ? "error" : "success",
                  };
                },
              },
            },
            createdTime: {
              text: "Created Time",
              sortable: true,
              options: {
                filter: "dateTime",
              },
            },
            updatedTime: {
              text: "Updated Time",
              sortable: true,
              options: {
                filter: "dateTime",
              },
            },
            action: {
              text: "Actions",
            },
          },
          template: {
            itemActionButtons: {
              edit: userManager.checkRole(["systemAdmin", "admin"]) && !userManager.checkRole(["cpoGroup"], true) && {
                target: {
                  dialog: {
                    ext: {
                      subTitleMaker: "name",
                    },
                  },
                },
                ext: {
                  condition(_, item) {
                      return !item.partyId;
                  },
                },
              },
              delete: userManager.checkRole(["systemAdmin", "admin"]) && !userManager.checkRole(["cpoGroup"], true) && {
                 ext: {
                  condition(_, item) {
                      return !item.partyId;
                  },
                },
              },
              disable: userManager.checkRole(["systemAdmin", "admin"]) && !userManager.checkRole(["cpoGroup"], true) && {
                content: {
                  icon(self) {
                    const { item } = self.context();
                    return item.disabled ? "mdi-toggle-switch-off-outline" : "mdi-toggle-switch-outline";
                  },
                  iconAttrsFunc(attrs: any = {}, self) {
                    const { item } = self.context();
                    attrs.color = item.disabled ? "error" : "success";
                    return attrs;
                  },
                },
                on: {
                  async xClick({ self }) {
                    const { item, dataTable } = self.context();
                    await dataTable.execute(".update", [{ ...item, disabled: !item.disabled }], {
                      willRefresh: true,
                      successMessage: `Organization: ${item.name} has been ${item.disabled ? "enabled" : "disabled"}`,
                    });
                  },
                },
                target: {
                  tooltip: {
                    content: {
                      text: "Enable/Disable",
                    },
                  },
                },
              },
              setActive: {
                content: {
                  icon: "mdi-hexagram",
                  iconAttrsFunc(attrs: any = {}, self) {
                    const { item } = self.context();
                    const activeTenant = appService.getActiveTenant();
                    if (activeTenant && activeTenant._id === item._id) {
                      attrs.color = "primary";
                    }
                    return attrs;
                  },
                },
                on: {
                  xClick({ self }) {
                    const { item, dataTable } = self.context();
                    const activeTenant = appService.getActiveTenant();
                    if (activeTenant && activeTenant._id === item._id) {
                      appService.deleteActiveTenant();
                      return;
                    }
                    appService.setActiveTenant(item);
                    dataTable.info.value = `Organization: ${item.name} is currently active`;
                  },
                },
                target: {
                  tooltip: {
                    content: {
                      text: "Set Active",
                    },
                  },
                },
                ext: {
                  condition(_, item) {
                      return !item.partyId;
                  },
                },
              },
            },
          },
          findAllOptionsFilter(options) {
            return options;
          },
        },
        ext: {
          dataProvider: {
            async findAll(options) {
              const { items, count } = await coreApiClient.call("tenants", "findAll", options);
              return [items, count];
            },
            async insert(item) {
              return await coreApiClient.call("tenants", "create", undefined, item);
            },
            async update(item) {
              return await coreApiClient.call(
                "tenants",
                "update",
                {
                  id: item._id,
                },
                {
                  data: item,
                }
              );
            },
            async delete(item) {
              return await coreApiClient.call("tenants", "delete", {
                id: item._id,
              });
            },
          },
          default: {
            defaultInputs: {
              name: {
                attrs: {
                  label: "Organization",
                  required: true,
                },
              },
              subdomain: {
                attrs: {
                  label: "Subdomain",
                  required: true,
                },
              },
              email: {
                type: "email",
                attrs: {
                  label: "Business Email",
                  required: true,
                },
              },
              isPostpaid: {
                type: "boolean",
                attrs: {
                  label: "Postpaid",
                },
              },
              crossPayment: {
                type: "boolean",
                attrs: {
                  label: "Cross Payment",
                },
                ext: {
                  defaultValue: true,
                },
              },
              "setting.isCrossCharging": {
                type: "boolean",
                attrs: {
                    label: "Cross Charging",
                },
                ext: {
                  defaultValue: true,
                  condition() {
                    return isFleetEnabled;
                  },
                },
              },
              "setting.isInvoiceEnabled": {
                type: "boolean",
                attrs: {
                  label: "Enable Invoice",
                },
                ext: {
                  defaultValue: true,
                },
              },
              "setting.chargingSessionPointPerKwh": {
                type: "number",
                attrs: {
                  label: "Electricity Tariff (per kWh)",
                  min: 0,
                  suffix: "per kWh",
                },
                ext: {
                  defaultValue: 0,
                },
              },
              ratio: {
                type: "number",
                attrs: {
                  label: "Ratio",
                  min: 0,
                  max: 1,
                  step: 0.01,
                },
                ext: {
                  defaultValue: 1,
                },
              },
              cpoGroupId: {
                type: "XAutocomplete",
                attrs: {
                  label: "Partner",
                  "item-value": "_id",
                  "item-text": "name",
                  clearable: true,
                  xOptions: {
                    content: {
                      async itemsSuggestor(search, value, limit) {
                        const { items } = await coreApiClient.call("cpoGroups", "findAll", {
                          payload: JSON.stringify({
                            limit,
                            search,
                            orderBy: "name",
                            orderType: "asc",
                            filters: [
                              {
                                key: "_id",
                                operator: "equal_to",
                                value,
                              },
                            ],
                          }),
                        });
                        return items;
                      },
                    },
                  },
                },
              },
            },
            insertForm: userManager.checkRole(["systemAdmin", "admin"]) && !userManager.checkRole(["cpoGroup"], true) && {
              content: {
                fieldNames: ["name", "subdomain", "email", "isPostpaid", "crossPayment",  isFleetEnabled && "setting.isCrossCharging", "setting.isInvoiceEnabled" , "setting.chargingSessionPointPerKwh", "ratio", "cpoGroupId"].filter(Boolean),
              },
            },
            editForm: userManager.checkRole(["systemAdmin", "admin"]) && !userManager.checkRole(["cpoGroup"], true) && {
              content: {
                fieldNames: ["name", "subdomain", "email",  isFleetEnabled && "setting.isCrossCharging", "setting.isInvoiceEnabled", "setting.chargingSessionPointPerKwh", "ratio", "cpoGroupId"].filter(Boolean),
              },
            },
            delete: {
              confirmDisplayField: "name",
            },
          },
        },
      },
    };
  },
});
